<template>      
    <v-row justify="center" align-content="center" align="center">
        <v-col order="2" order-sm="1" order-md="1" order-lg="1" order-xl="1" class="text-center col-xs-12 ">
            <v-row justify="center" align-content="center" align="center">
                <span class='font-crono'> 
                    {{this.votosMenino}} 
                </span>                    
            </v-row>
            <v-row justify="center" align-content="center">
                <span class='title font-white'>                     
                    Pessoas acham que é <br>{{this.babyData.nomeMenino}}
                </span>      
            </v-row>  
            <v-row justify="center" align-content="center">
                <v-btn  outlined color="#FFFFFF" class="ml-3" x-large dark @click="votoMenino">
                    Eu acho que é {{this.babyData.FirstNameMenino}}
                </v-btn>                    
            </v-row>                              
        </v-col>
        <v-col order="1" order-md="2" order-lg="2" order-xl="2" class="text-center col-xs-12">
            <span class="font-crono-span2">FALTAM</span>
            <countdown :time="this.babyData.contagem" @end="startCha">         
                <template slot-scope="props">
                    <v-row>
                        <v-col cols="3">
                            <v-card dark color="black" class="font-crono">
                                {{ props.days }}
                                <span class="font-crono-span">DIAS</span>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card dark color="black" class="font-crono">
                                    {{ props.hours }}
                                    <span class="font-crono-span">HORAS</span>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card dark color="black" class="font-crono">
                                {{ props.minutes }} 
                                <span class="font-crono-span">MINUTOS</span>
                            </v-card>
                        </v-col>
                        <v-col cols="3">
                            <v-card dark color="black" class="font-crono">
                                {{ props.seconds }}
                                <span class="font-crono-span">SEGUNDOS</span>
                            </v-card>
                        </v-col>                                                                                               
                    </v-row>                                                                                 
                </template>
            </countdown> 
            <span class="font-crono-span2">PARA A REVELAÇÃO</span>
            <v-row justify="center" align-content="center">
                <v-col cols="12">
                    <v-row justify="center" align-content="center">
                        <presentear v-if="((typeof this.babyData.endereco != 'undefined') && (typeof this.babyData.listaPresentes != 'undefined'))" :endereco="this.babyData.endereco" :presentes="this.babyData.listaPresentes"/>                 
                    </v-row>                            
                </v-col>
                <v-col cols="12">
                    <v-row justify="center" align-content="center">
                        <mensagem :revelacaoId="this.babyData.id" :url="this.babyData.URL" v-on:loadMessage="loadMessage"/>
                    </v-row>                            
                </v-col>                                                            
            </v-row>
        </v-col>             
        <v-col order="3" order-sm="3" order-md="3" order-lg="3" order-xl="3" class="text-center col-xs-12">
            <span class='font-crono'> 
                {{this.votosMenina}} <br> 
            </span>                
            <span class='title font-white'> 
                Pessoas Acham que é <br>{{this.babyData.nomeMenina}}<br>
            </span>
            <v-btn  outlined color="#FFFFFF" class="" x-large dark @click="votoMenina">
                Eu acho que é {{this.babyData.FirstNameMenina}}
            </v-btn>
        </v-col>            
    </v-row>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script>
import * as firebase from "firebase"
import presentear from "@/components/presentearComponent"
import mensagem from "@/components/messagePage"
import {db} from '@/main.js'

export default {
    components:{presentear,mensagem},
    props: ['babyData'],
    data: () => ({
        url: '',
        key: 0,
        db: '',
        contagem: new Date().getTime(),
        room: '',
        userName: '',
        revelaType: '',
        votosMenino: 0,
        votosMenina: 0,
        sexo: '',
        nomeReal: '',
        revelationId: '',
        encerrado: false,
        ct2: new Date().getTime() + 7200000,         
    }),
    async created(){
        await setTimeout(()=>{}, 5000);
        this.loadVotos()
    },
    methods:{   
        loadMessage(){
            this.$emit('loadMessage')
        },    
        async startCha(){
            this.$emit('startCha')         
        },
        async loadVotos(){
            // console.log(this.$route.params.pathURL)
            await db.collection('revelacoes').where('URL','==',this.$route.params.pathURL).get()
            .then((seg) => {    
                this.votosMenino = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a.votosMenino || 0})[0];                    
                this.votosMenina = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a.votosMenina || 0})[0];
            }).catch(function (error) {
                console.error("Error get Votos: ", error);
            }); 
        },
        async votoMenino(){
            await this.loadVotos()
            this.votosMenino += 1
            let infoVoto = {
                'votosMenino': this.votosMenino,
                'votosMenina': this.votosMenina
            }

            db.collection('revelacoes').doc(this.babyData.id).update(infoVoto).then(async() => {
                this.loading = false
            }).catch(function (error) {
                console.error('Error to Save Information - storePage : ' + error)
            })             
        },
        async votoMenina(){
            await this.loadVotos()
            this.votosMenina += 1
            let infoVoto = {
                'votosMenino': this.votosMenino,
                'votosMenina': this.votosMenina
            }

            db.collection('revelacoes').doc(this.babyData.id).update(infoVoto).then(async() => {
                this.loading = false
            }).catch(function (error) {
                console.error('Error to Save Information - storePage : ' + error)
            })             
        },              
    },      
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Share+Tech+Mono');

#teste-template {
  height: 100% !important;
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;
}
#teste-template-f {
  height: 100% !important;
  background: #f59cd3;
  /* background-size: cover; */
}
#teste-template-m {
  height: 100% !important;
  background: #51c7fd;
  /* background-size: cover; */
}

#jitsi-container {
    height:100px
}
.font-crono {
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 5em;
    line-height: 1;
} 

@media (max-width: 380px) {
    .font-crono {
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em;
        line-height: 1;
    }; 
    .font-crono-span{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 3.5em!important;
        color: rgb(196, 29, 29)!important
    }
    .font-crono-span2{
        font-family: 'Share Tech Mono', sans-serif;
        font-size: 2.3em!important;
        color: white!important    
    }        
}

.font-crono-span{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 0.27em!important;
    color: white!important
}
.font-crono-span2{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 4.3em!important;
    color: white!important    
}

.font-crono-span-revela{
    font-family: 'Share Tech Mono', sans-serif;
    font-size: 2.3em!important;
    color: white!important    
}
.transparent {
   background-color: white!important;
   opacity: 0;
   border-color: transparent!important;
}
.font-white{
       color: white!important;
}

 .share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF !important;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>